import { useAppDispatch } from '@/app/hooks';
import AffectationsTable from '@/components/Affectations/AffectationsTable';
import { openAffectationFormDrawer } from '@/features/drawer/drawerSlice';
import { useUserAffectations } from '@/shared/auth/useUserAffectations';
import { Button, Center, Group, Loader, Stack, Text, Title } from '@mantine/core';
import { useDocumentTitle } from '@mantine/hooks';
import { IconPlus } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';

const ProfileAffectationsPage = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslate();

  const { data: affectations = [], isLoading } = useUserAffectations();

  useDocumentTitle(t('profil.affectations.title'));

  const openAddAffectationDrawer = () => {
    dispatch(openAffectationFormDrawer(t('profil.affectations.add')));
  };

  return (
    <Stack gap="md">
      <Group justify="space-between" align="center">
        <Title order={1}>{t('profil.affectations.title')}</Title>
        <Button leftSection={<IconPlus size={16} />} onClick={openAddAffectationDrawer}>
          {t('profil.affectations.add')}
        </Button>
      </Group>

      {isLoading ? (
        <Center h={200}>
          <Loader size="sm" />
        </Center>
      ) : affectations.length === 0 ? (
        <Text c="dimmed">{t('profil.affectations.empty')}</Text>
      ) : (
        <AffectationsTable affectations={affectations} />
      )}
    </Stack>
  );
};

export default ProfileAffectationsPage;
